import React, { useState } from 'react';

import { Insertion, LayoutModel } from '@paragon/contract-library';
import { changeInsertionQuantity, getQuantityMap } from '@paragon/layout-models';
import { NumericField } from '@paragon/material';

import { useAppDispatch, useAppSelector } from '../../hooks';

export function QuantityField(props: { model: LayoutModel; parentGuid: string }) {
  const dispatch = useAppDispatch();
  const quantityMap = useAppSelector(getQuantityMap);

  const [key, setKey] = useState(0);

  const quantity = quantityMap[props.model.guid][props.parentGuid];

  return (
    <NumericField
      key={key}
      label="Quantity"
      value={quantity}
      min={1}
      integers
      onSubmit={(newQuantity) => {
        const insertion: Insertion = {
          type: props.model.category === 'componentDesigns' ? 'NormalComponent' : 'HierarchyModel',
          parentGuid: props.parentGuid,
          objectGuid: props.model.guid,
        };
        dispatch(changeInsertionQuantity(insertion, newQuantity - quantity));
        setKey((key) => key + 1);
      }}
    />
  );
}
